import { render, staticRenderFns } from "./StepFourSMS.vue?vue&type=template&id=578159c3&lang=pug"
import script from "./StepFourSMS.vue?vue&type=script&lang=ts"
export * from "./StepFourSMS.vue?vue&type=script&lang=ts"
import style0 from "./StepFourSMS.vue?vue&type=style&index=0&id=578159c3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports